import {AutoComplete, Button, Card, Form, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByTypeForTpwModule, sanitizeFieldName} from "../../util/methods";
import SubListTpw from "../../components/SubListTpw";
import DocumentList from "../../components/DocumentList";

class Create extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      documentData: [],
    };
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillUnmount() {
   this.props && this.props.clearProps();
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);
      const { documentData } = this.state;
      // data.documents = documentData;
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData ;
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        //console.log(values);
        this.props.onSubmit(data);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, tpw, subDocumentFilters} = this.props;
    const tpwStyle = {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between'
    }
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {Object.keys(filters).map((item) => {
              if (item === 'tpwNo') {
              return <Form.Item key={'tpwSearchQuery'} label={'Search Tpw'}>
                { getFieldDecorator(item, {
                  rules: [{
                    required: filters[item].options.required ? filters[item].options.required : '',
                    message: `tpw is required!`
                  }],
                  initialValue: (title === 'EDIT') ? (data && data.tpwNo) ? data.tpwNo : [] : [],
                })(
                      <AutoComplete
                        showSearch={true}
                        placeholder={'ex. tpw'}
                        disabled={title === 'EDIT'}
                        onSearch={this.props.fetchTpwNo}>
                        {
                          tpw && tpw.data && tpw.data.map((item) => {
                            return <Select.Option key={item._id} value={item['tpwNo']}>{item['tpwNo']}</Select.Option>
                          })
                        }
                      </AutoComplete>
                )}
              </Form.Item>
              }

              /*return <Form.Item key={item}
                           label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                  {getFieldDecorator(item, {
                    rules: [{
                      required: filters[item].options.required ? filters[item].options.required : '',
                      message: `${filters[item].options.label ? filters[item].options.label : item} is required!`
                    }],
                    //initialValue: (title === 'EDIT') ? (data && data.activitySerialNo && data.activitySerialNo.length) ? data.activitySerialNo : [] : [],
                  })(<Select
                    allowClear
                    showArrow={true}
                    placeholder={`Please Select ${sanitizeFieldName(filters[item].field)}`}
                    disabled={title === 'EDIT' && filters[item].options.disabledOnEdit}
                  >
                    {tpw && tpw.map(item => <Select.Option key={item['tpwNo']}>{item['tpwNo']}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
                //return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>
              } */
                else if(filters[item].type === 'Array' && filters[item].schema) {
                return<div key={filters[item] && filters[item].field ? filters[item].field : filters[item]}>
                  {filters[item] && filters[item].field ? sanitizeFieldName(filters[item].field) : ''}
                  <SubListTpw key={item} item={filters[item]} disableAll = {this.props && this.props.disableAll} form={form} data={data[item]} title={title} resource={resource} storeTotalData = {this.props.storeTotalData} searchData={this.props.searchData}/>
                </div>
              }
            })}
            <div key = {'formItems'} style={tpwStyle}>
              {
                Object.keys(filters).map((item) => {
                  if(item ==='date' || item ==='vendor' || item === 'targetDateOfCompletion' || item === 'totalCost') {
                    let spareValue = [], labourValue = [];
                      spareValue = this.props && this.props.sparesData;
                      labourValue = this.props && this.props.labourData;

                    return getFormFieldByTypeForTpwModule(filters, item, getFieldDecorator, data, {resource, title, spareValue, labourValue, disableMaster: this.props && this.props.disableMaster});
                  }
                  // Document Upload Form
                  else if (filters[item].type === 'Array' && filters[item].options.ref) {
                    return <DocumentList match={this.props.match} history={this.props.history}
                                         key={item} item={filters[item]} form={form} data={data[item]}
                                         subDocumentFilters={subDocumentFilters} resource={resource} title={title} hideRemove={title && title ==='EDIT'} hideEdit = {true}
                                         getDocumentData={this.getDocumentData}/>
                  }
                })}
            </div>
            {
              title === 'EDIT' ?
                <Form.Item key={'status'} label={'Status'}>
                  <Select style = {{width: '190px'}} showArrow={false} disabled={true} value={(data && data.status) ? data.status : ''} />
                </Form.Item> : ''
            }
            {
              title === 'CREATE' ?
                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>CREATE</Button>
                </Form.Item> : ''
            }
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
